import React from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-113">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-114" />
      <div className="absolute inset-0 bg-gradient-to-b from-familia-bg to-familia-section opacity-50 pointer-events-none" data-id="element-115" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-2 pb-6 text-center" data-id="element-116">
        <p className="text-familia-gold font-semibold text-[10px] sm:text-xs uppercase tracking-[0.25em] mb-1" data-id="element-117">
          English en Familia · Mega Pack Bilingüe
        </p>

        <h1 className="font-display sm:text-4xl md:text-5xl font-bold mb-2 text-[20px]" data-id="element-118">
          El Sistema Completo para Preparar <br className="hidden md:block" data-id="element-119" />
          Cambridge en Familia —{' '}
          <span className="text-familia-cyan" data-id="element-120">Sin Saber Inglés</span>
        </h1>

        <div className="relative max-w-[180px] sm:max-w-[260px] mx-auto mb-3" data-id="element-121">
          <div aria-hidden="true" className="absolute inset-0 bg-familia-cyan/25 rounded-full hidden sm:block" style={{
          filter: 'blur(50px)'
        }} data-id="element-122" />
          <img src="https://cdn.magicpatterns.com/uploads/1gogxkHTXKLRUBaowas8sp/hf_20260522_191029_7a20001b-07c9-47a6-aa30-37cdc35dcae1-removebg-preview.png" alt="English en Familia Mega Pack Bilingüe Cambridge Mockup" width="500" height="500" loading="eager" decoding="async"
        // @ts-ignore
        fetchpriority="high" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-123" />
        </div>

        <p className="text-familia-gray sm:text-sm max-w-xl mx-auto mb-3 text-[10px] leading-relaxed" data-id="element-124">
          3 Módulos + 3 Bonos: Young Learners, Teens Bridge, Grammar Guide,
          Flashcards Bilingües, Speaking Cards y Planificación Express. Todo
          explicado. En inglés y en español. Sin improvisar. Sin adivinar.{' '}
          <span className="text-white font-semibold" data-id="element-125">
            Sin necesitar saber inglés.
          </span>
        </p>

        <div className="flex flex-wrap gap-1 mb-3 items-start justify-center" data-id="element-126">
          {['📄 PDF Digital', '⚡ Acceso Inmediato', '🎓 Familias Cambridge', '💥 Sistema Completo', '🇦🇷 Hecho para Argentina'].map((badge, i) => <span key={i} className="bg-familia-card border border-familia-cyan/25 px-2.5 py-1 rounded-full text-[9px] sm:text-[11px] font-bold flex items-center gap-1.5" data-id="element-127">
              {badge}
            </span>)}
        </div>

        <CTAButton href="#precio-lanzamiento" className="w-full sm:w-auto text-base px-10 py-3.5 mb-3" data-id="element-128">
          →LO QUIERO AHORA
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-[9px] sm:text-[11px] text-familia-gray" data-id="element-129">
          <span className="flex items-center gap-1.5" data-id="element-130">
            🛡️ Garantía de satisfacción de 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-131">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-132">
            💳 Tarjeta · Mercado Pago · Ualá · Transferencia
          </span>
        </div>
      </div>
    </header>;
};